import '../assets/NcAppNavigationList.css';
import { defineComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, normalizeStyle, renderSlot } from "vue";
import { A as APP_NAVIGATION_HIGHLIGHT } from "./highlight.mjs";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _sfc_main = defineComponent({
  name: "NcAppNavigationList",
  provide() {
    return {
      [APP_NAVIGATION_HIGHLIGHT]: {
        show: this.show,
        hide: this.hide
      }
    };
  },
  data() {
    return {
      /** Entry the highlight is on, as reported by that entry itself */
      entry: null,
      /** Whether the highlight is shown */
      visible: false,
      /** Whether position changes should transition (slide) or snap */
      animated: false,
      /** Whether the highlight sits on the active entry (turns transparent) */
      overActive: false,
      /** Vertical offset of the highlight inside the scrollable content */
      top: 0,
      /** Height of the highlight */
      height: 0,
      /** Pending animation frame for re-measuring while scrolling */
      scrollFrame: 0
    };
  },
  computed: {
    highlightStyle() {
      return {
        transform: `translateY(${this.top}px)`,
        height: `${this.height}px`
      };
    }
  },
  beforeUnmount() {
    if (this.scrollFrame) {
      cancelAnimationFrame(this.scrollFrame);
    }
  },
  methods: {
    /**
     * Move the highlight onto an entry. It slides there if already visible,
     * otherwise it snaps into place so it does not slide in from the entry
     * that was hovered before. Over the active entry it turns transparent so
     * that entry keeps its own static highlight.
     *
     * @param entry the entry element asking for the highlight
     */
    show(entry) {
      this.entry = entry;
      this.overActive = entry.classList.contains("active");
      if (this.visible) {
        this.animated = true;
        this.measure();
        return;
      }
      this.animated = false;
      this.measure();
      this.visible = true;
      this.$nextTick(() => requestAnimationFrame(() => {
        this.animated = true;
      }));
    },
    /**
     * Hide the highlight if it is on the given entry, e.g. because that entry
     * is being removed. While the pointer only moves between entries the
     * highlight stays visible, so it can slide on to the next one.
     *
     * @param entry the entry element that no longer wants the highlight
     */
    hide(entry) {
      if (this.entry === entry) {
        this.hideNow();
      }
    },
    /** Hide the highlight, as the pointer or focus left the list */
    hideNow() {
      this.visible = false;
    },
    /**
     * Hide the highlight once focus leaves the list entirely
     *
     * @param event the focusout event
     */
    onFocusOut(event) {
      const list = this.$refs.list;
      if (!list.contains(event.relatedTarget)) {
        this.hideNow();
      }
    },
    /** Read the current entry's geometry relative to the list content */
    measure() {
      const list = this.$refs.list;
      if (!list || !this.entry) {
        return;
      }
      const entryRect = this.entry.getBoundingClientRect();
      const listRect = list.getBoundingClientRect();
      this.top = entryRect.top - listRect.top + list.scrollTop;
      this.height = entryRect.height;
    },
    /**
     * Keep the highlight on its entry while scrolling. Needed because a
     * virtual scroller repositions its entries as the list scrolls.
     */
    onScroll() {
      if (!this.visible || this.scrollFrame) {
        return;
      }
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = 0;
        this.measure();
      });
    }
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("ul", {
    ref: "list",
    class: normalizeClass(["app-navigation-list", { "app-navigation-list--animated-highlight": _ctx.visible }]),
    onPointerleave: _cache[0] || (_cache[0] = (...args) => _ctx.hideNow && _ctx.hideNow(...args)),
    onFocusout: _cache[1] || (_cache[1] = (...args) => _ctx.onFocusOut && _ctx.onFocusOut(...args)),
    onScrollPassive: _cache[2] || (_cache[2] = (...args) => _ctx.onScroll && _ctx.onScroll(...args))
  }, [
    createElementVNode("div", {
      class: normalizeClass(["app-navigation-list__highlight", {
        "app-navigation-list__highlight--visible": _ctx.visible,
        "app-navigation-list__highlight--animated": _ctx.animated,
        "app-navigation-list__highlight--over-active": _ctx.overActive
      }]),
      style: normalizeStyle(_ctx.highlightStyle),
      "aria-hidden": "true"
    }, null, 6),
    renderSlot(_ctx.$slots, "default", {}, void 0, true)
  ], 34);
}
const NcAppNavigationList = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-3e73e246"]]);
export {
  NcAppNavigationList as N
};
//# sourceMappingURL=NcAppNavigationList.mjs.map
